import { Menu, X } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { navigation } from "../../data/navigation";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import { useEscapeKey } from "../../hooks/useEscapeKey";
import { BrandLogo } from "../shared/BrandLogo";
import { WhatsAppLink } from "../shared/WhatsAppLink";

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [compact, setCompact] = useState(false);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  useBodyScrollLock(menuOpen);
  useEscapeKey(() => {
    closeMenu();
    menuButtonRef.current?.focus();
  }, menuOpen);

  useEffect(() => {
    closeMenu();
  }, [closeMenu, pathname]);
  useEffect(() => {
    const onScroll = () => setCompact(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    if (menuOpen) closeButtonRef.current?.focus();
  }, [menuOpen]);

  return (
    <header className={`site-header ${compact ? "site-header--compact" : ""}`}>
      <div className="container site-header__inner">
        <BrandLogo />
        <nav className="desktop-nav" aria-label="Navegação principal">
          {navigation.map((item) => (
            <Link key={item.to} to={item.to} activeOptions={{ exact: item.to === "/" }} activeProps={{ className: "active" }}>
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="site-header__actions">
          <WhatsAppLink className="button button--primary header-cta">Encomendar</WhatsAppLink>
          <button
            ref={menuButtonRef}
            className="menu-toggle"
            type="button"
            aria-label="Abrir menu"
            aria-expanded={menuOpen}
            aria-controls="mobile-menu"
            onClick={() => setMenuOpen(true)}
          >
            <Menu aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="mobile-menu-backdrop" role="presentation" onMouseDown={closeMenu}>
          <div id="mobile-menu" className="mobile-menu" role="dialog" aria-modal="true" aria-label="Menu de navegação" onMouseDown={(event) => event.stopPropagation()}>
            <div className="mobile-menu__top">
              <BrandLogo />
              <button ref={closeButtonRef} className="menu-toggle" type="button" aria-label="Fechar menu" onClick={closeMenu}>
                <X aria-hidden="true" />
              </button>
            </div>
            <nav aria-label="Navegação mobile">
              {navigation.map((item) => (
                <Link key={item.to} to={item.to} activeOptions={{ exact: item.to === "/" }} activeProps={{ className: "active" }} onClick={closeMenu}>
                  {item.label}
                </Link>
              ))}
            </nav>
            <WhatsAppLink className="button button--whatsapp button--full">Encomendar pelo WhatsApp</WhatsAppLink>
          </div>
        </div>
      )}
    </header>
  );
}
